<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom: 60px;">About the Author</h1>
<p>Fil Bufalo has been writing for a lifetime—on the sand, on slate and in shorthand. An animated storyteller and accomplished raconteur, she has gathered all her thoughts, philosophies and musings on life into a bonfire of words and taken the plunge with a match.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1d17a31e